import React from 'react';
import './Skeleton.css';

/**
 * Loading-placeholder skeletons for the primary lists (Fas 11E).
 *
 * Each export renders class-only pulsing placeholders that mirror the real
 * layout, so the page keeps its shape while data loads instead of flashing a
 * bare spinner. Purely presentational and `aria-hidden`.
 */

/**
 * Placeholder rows mirroring the PlayersList table.
 *
 * @param {object} props
 * @param {number} [props.rows=10] - Number of placeholder rows to render.
 * @returns {JSX.Element}
 */
export const PlayersListSkeleton = ({ rows = 10 }) => (
  <div className="skeleton-players" aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div className="skeleton-player-row" key={i}>
        <span className="skeleton skeleton-avatar" />
        <span className="skeleton skeleton-bar skeleton-bar-name" />
        <span className="skeleton skeleton-bar" />
        <span className="skeleton skeleton-bar" />
        <span className="skeleton skeleton-bar" />
      </div>
    ))}
  </div>
);

/**
 * Placeholder cards mirroring the MatchesList grid.
 *
 * @param {object} props
 * @param {number} [props.cards=6] - Number of placeholder cards to render.
 * @returns {JSX.Element}
 */
export const MatchesListSkeleton = ({ cards = 6 }) => (
  <div className="skeleton-matches" aria-hidden="true">
    {Array.from({ length: cards }).map((_, i) => (
      <div className="skeleton-match-card" key={i}>
        <span className="skeleton skeleton-bar skeleton-bar-map" />
        <div className="skeleton-match-teams">
          <span className="skeleton skeleton-bar" />
          <span className="skeleton skeleton-bar skeleton-bar-score" />
          <span className="skeleton skeleton-bar" />
        </div>
      </div>
    ))}
  </div>
);
